import {
  CLEAR_QR_SCAN_LOG_QUERY,
  CREATE_QR_SCAN_LOG_SUCCESS,
  FETCH_QR_SCAN_LOG_SUCCESS,
  GET_QR_SCAN_LOG_SUCCESS,
  SAVE_QR_SCAN_LOG_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  success: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_QR_SCAN_LOG_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_QR_SCAN_LOG_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_QR_SCAN_LOG_SUCCESS: {
      return {
        ...state,
        resource: action.data,
        success: action.data.success
      }
    }

    case FETCH_QR_SCAN_LOG_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case CLEAR_QR_SCAN_LOG_QUERY: {
      return {
        ...state,
        success: null,
      }
    }

    default:
      return state;
  }
}
